var exports = {
  "Lw": "overlay__Q1byM6",
  "vP": "dropdownIcon__YTEfIy",
  "VS": "cliDescription__JjF9fY",
};

module.exports = exports;
